(() => {
  function installer(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('form');
    const fields = root.querySelector('.df-revendeurs__fields');
    const status = root.querySelector('[role="status"]');
    const submit = form.querySelector('[type="submit"]');
    const reconnect = form.querySelector('[data-reconnect]');
    const nouvelle = form.querySelector('[data-new]');
    const messages = JSON.parse(root.querySelector('[data-messages]').textContent);
    const photoSelection = root.querySelector('[data-photo-selection]');
    const details = root.querySelectorAll('[data-form-details]');
    const endpoint = root.dataset.endpoint;
    function afficherPhotos() {
      if (!photoSelection) return;
      photoSelection.textContent = Array.from(form.elements.photos.files, f => f.name).join(' · ') || messages.photo_choose;
    }
    form.elements.photos.addEventListener('change', afficherPhotos);
    const storageKey = 'df-revendeurs-request';
    let id;
    try { id = sessionStorage.getItem(storageKey); } catch { /* navigation privée restrictive */ }
    if (!/^[a-f0-9-]{36}$/i.test(id || '')) id = crypto.randomUUID();
    function retenir() { try { sessionStorage.setItem(storageKey, id); } catch { /* l'id reste en mémoire */ } }
    retenir();
    let modeCourant;
    let jeton; let busy = false; let reprise = false;
    function afficher(message, focus = false) {
      status.textContent = message; status.hidden = false;
      if (focus) status.focus();
    }
    async function appel(route, options = {}) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 40000);
      try {
        const response = await fetch(`${endpoint}/${route}`, { ...options, cache: 'no-store', signal: controller.signal,
          headers: { Accept: 'application/json', 'X-Revendeur-Id': id, ...(jeton ? { 'X-Revendeur-Token': jeton } : {}), ...options.headers } });
        if (!(response.headers.get('content-type') || '').includes('application/json')) throw new Error('response_invalide');
        const data = await response.json();
        if (!response.ok || data.error) throw Object.assign(new Error(data.error || 'indisponible'), { code: data.error });
        return data;
      } finally { clearTimeout(timer); }
    }
    function afficherEtat(data, focus = false) {
      if (!['enregistre', 'envoye'].includes(data.statut) || data.id !== id) throw new Error('response_invalide');
      reprise = true;
      details.forEach(e => { e.hidden = true; });
      fields.hidden = true; fields.disabled = true; form.noValidate = true;
      const message = data.statut === 'envoye' ? messages.success : data.commercial === 'envoye' ? messages.ack_pending : messages.pending;
      afficher(`${message}\n${messages.reference} : ${id}`, focus);
      submit.hidden = data.statut === 'envoye';
      submit.textContent = messages.retry;
      nouvelle.hidden = false;
    }
    async function initialiser() {
      submit.disabled = true; reconnect.hidden = true;
      try {
        let donnees = await appel(`jeton?id=${encodeURIComponent(id)}`);
        let ancienMode;
        try { ancienMode = sessionStorage.getItem('df-revendeurs-mode'); } catch { /* mémoire seule */ }
        if ((ancienMode || modeCourant) !== donnees.mode) {
          id = crypto.randomUUID(); retenir();
          try { sessionStorage.setItem('df-revendeurs-mode', donnees.mode); } catch { /* mémoire seule */ }
          donnees = await appel(`jeton?id=${encodeURIComponent(id)}`);
        }
        modeCourant = donnees.mode;
        if (typeof donnees.jeton !== 'string') throw new Error('response_invalide');
        jeton = donnees.jeton;
        const etat = await appel(`etat?id=${encodeURIComponent(id)}`);
        if (etat.statut !== 'absent') afficherEtat(etat);
        submit.disabled = false;
      } catch { afficher(messages.error); reconnect.hidden = false; }
    }
    reconnect.addEventListener('click', () => { if (!busy) initialiser(); });
    nouvelle.addEventListener('click', () => {
      id = crypto.randomUUID(); retenir(); jeton = null; reprise = false;
      form.reset(); afficherPhotos(); details.forEach(e => { e.hidden = false; }); form.noValidate = false; fields.disabled = false; fields.hidden = false;
      status.hidden = true; submit.hidden = false; submit.textContent = messages.submit; nouvelle.hidden = true;
      initialiser();
    });
    form.addEventListener('invalid', event => { if (event.target.setCustomValidity) event.target.setCustomValidity(messages.invalid); }, true);
    form.addEventListener('input', event => { if (event.target.setCustomValidity) event.target.setCustomValidity(''); });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || !jeton) return;
      if (!reprise && !form.reportValidity()) return;
      const fichiers = Array.from(form.elements.photos.files);
      if (!reprise && (fichiers.length > 2 || fichiers.some(f => f.size > 2 * 1024 * 1024 || !['image/jpeg', 'image/png', 'image/webp'].includes(f.type)))) {
        afficher(messages.photo_error, true); return;
      }
      busy = true; submit.disabled = true; nouvelle.disabled = true;
      submit.textContent = messages.sending; form.setAttribute('aria-busy', 'true');
      try {
        // Renouveler le jeton avant un formulaire resté ouvert longtemps.
        const renouvellement = await appel(`jeton?id=${encodeURIComponent(id)}`);
        if (renouvellement.mode !== modeCourant) throw new Error('mode_modifie');
        jeton = renouvellement.jeton;
        const data = await appel(reprise ? 'reprise' : 'demandes', { method: 'POST', ...(reprise ? {} : { body: new FormData(form) }) });
        afficherEtat(data, true);
      } catch (e) {
        // Un timeout peut suivre un COMMIT acquis. Lire l'état avant d'afficher
        // une erreur et conserver toujours la même clé pour la prochaine reprise.
        let retrouve = false;
        if (e.message === 'mode_modifie') { jeton = null; afficher(messages.updated, true); retrouve = true; }
        if (e.code === 'contenu_modifie') { afficher(messages.changed, true); nouvelle.hidden = false; retrouve = true; }
        try { if (retrouve) throw new Error('conflit'); const etat = await appel(`etat?id=${encodeURIComponent(id)}`); if (etat.statut !== 'absent') { afficherEtat(etat, true); retrouve = true; } } catch { /* réseau encore indisponible */ }
        if (!retrouve) afficher(e.code === 'photo_invalide' ? messages.photo_error : e.code === 'limite' ? messages.limit : e.code === 'contenu_modifie' ? messages.changed : ['champs_requis', 'champs_invalides', 'email_invalide'].includes(e.code) ? messages.invalid : messages.error, true);
      } finally {
        busy = false; submit.disabled = !jeton; nouvelle.disabled = false; form.removeAttribute('aria-busy');
        submit.textContent = reprise ? messages.retry : messages.submit;
      }
    });
    initialiser();
  }
  document.querySelectorAll('[data-df-revendeurs]').forEach(installer);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-df-revendeurs]').forEach(installer));
})();
